import type { ClientArea, ClientAreaLocation } from '@game/shared-types';

import type { MenuData } from '../types/menu.types';

export const createMenuObject = (location: ClientAreaLocation): MenuData => {
  return {
    destination: location.name,
    path: `/${location.slug}`,
    key: location.name.toLowerCase().replace(' ', '-'),
    missions: location.missions,
    imageUrl: location.imageUrl,
    type: location.type,
    content: <span>{location.menuText}</span>,
  };
};

export const generateLocationsMenu = (area: ClientArea): MenuData[] | [] => {
  if (area.locations.length > 0) {
    return area.locations.map((location) => createMenuObject(location));
  }
  return [];
};
